import { Parse } from "parse";

Parse.initialize(
  process.env.REACT_APP_APP_ID,
  null,
  process.env.REACT_APP_MASTER_KEY
);
Parse.masterKey = process.env.REACT_APP_MASTER_KEY;
Parse.serverURL = process.env.REACT_APP_SERVER_URL;

export const userSummary = async () => {
  try {
    const currentUser = Parse.User.current();

    const now = new Date();
    const startOfWeek = new Date(now);
    startOfWeek.setDate(now.getDate() - now.getDay() + 1); // Monday
    startOfWeek.setHours(0, 0, 0, 0);

    const startOfDay = new Date(now);
    startOfDay.setHours(0, 0, 0, 0);

    // Total Users (excluding current)
    const totalUsersQuery = new Parse.Query(Parse.User);
    totalUsersQuery.notEqualTo("objectId", currentUser.id);
    const totalUsersPromise = totalUsersQuery.count();

    // New Users This Week
    const newUsersQuery = new Parse.Query(Parse.User);
    newUsersQuery.greaterThanOrEqualTo("createdAt", startOfWeek);
    const newUsersPromise = newUsersQuery.count();

    // Active Users Today
    const activeUsersQuery = new Parse.Query(Parse.User);
    activeUsersQuery.greaterThanOrEqualTo("lastLogin", startOfDay);
    const activeUsersPromise = activeUsersQuery.count();

    // Currently Online Users who also logged in today
    const onlineUsersQuery = new Parse.Query(Parse.User);
    onlineUsersQuery.equalTo("isOnline", true);
    onlineUsersQuery.greaterThanOrEqualTo("lastLogin", startOfDay);
    const onlineUsersPromise = onlineUsersQuery.count();

    const [
      totalUsers,
      newUsersThisWeek,
      activeUsersToday,
      currentlyOnlineUsers,
    ] = await Promise.all([
      totalUsersPromise,
      newUsersPromise,
      activeUsersPromise,
      onlineUsersPromise,
    ]);

    return {
      totalUsers,
      newUsersThisWeek,
      activeUsersToday,
      currentlyOnlineUsers,
    };
  } catch (error) {
    console.log("userSummary error:", error);
    return { error: "Failed to generate userSummary." };
  }
};


export const hoteGames = async () => {
  try {
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

    // -------------------- VEGAS GAME PIPELINE --------------------
    const vegasPipeline = [
      {
        $match: {
          createdAt: { $gte: sevenDaysAgo },
        },
      },
      {
        $addFields: {
          gameIdStr: {
            $replaceOne: {
              input: "$_p_gameId",
              find: "GameCatalogue$",
              replacement: "",
            },
          },
        },
      },
      {
        $lookup: {
          from: "GameCatalogue",
          localField: "gameIdStr",
          foreignField: "_id",
          as: "gameInfo",
        },
      },
      { $unwind: "$gameInfo" },
      {
        $project: {
          gameName: "$gameInfo.name",
          _p_gameId: 1,
        },
      },
      {
        $group: {
          _id: { $concat: ["vegas_", "$_p_gameId"] },
          count: { $sum: 1 },
          gameName: { $first: "$gameName" },
          type: { $first: "VE" },
        },
      },
      {
        $sort: {
          count: -1,
        },
      },
    ];

    const resultVegasGame = await new Parse.Query("VegasGameHistory").aggregate(
      vegasPipeline,
      { useMasterKey: true }
    );

    // -------------------- TADA GAME PIPELINE --------------------
    const tadaPipeline = [
      {
        $match: {
          createdAt: { $gte: sevenDaysAgo },
        },
      },
      {
        $group: {
          _id: "$tadaSessionKey",
          gameId: { $first: "$gameId" },
        },
      },
      {
        $group: {
          _id: "$gameId",
          count: { $sum: 1 },
          type: { $first: "TD" },
        },
      },
      {
        $addFields: {
          gameName: {
            $switch: {
              branches: [
                {
                  case: { $eq: ["$_id", 265] },
                  then: "Crazy 777",
                },
                {
                  case: { $eq: ["$_id", 266] },
                  then: "Bone Fortune",
                },
                {
                  case: { $eq: ["$_id", 267] },
                  then: "Money Coming",
                },
                {
                  case: { $eq: ["$_id", 270] },
                  then: "Golden Joker",
                },
                {
                  case: { $eq: ["$_id", 275] },
                  then: "Charge Buffalo",
                },
                {
                  case: { $eq: ["$_id", 277] },
                  then: "Golden Bank",
                },
                {
                  case: { $eq: ["$_id", 279] },
                  then: "Magic Lamp",
                },
                {
                  case: { $eq: ["$_id", 281] },
                  then: "Alibaba",
                },
                {
                  case: { $eq: ["$_id", 282] },
                  then: "Gold Rush",
                },
                {
                  case: { $eq: ["$_id", 284] },
                  then: "Wild Racer",
                },
                {
                  case: { $eq: ["$_id", 285] },
                  then: "Shanghai Beauty",
                },
                {
                  case: { $eq: ["$_id", 296] },
                  then: "Mega Fishing",
                },
                {
                  case: { $eq: ["$_id", 306] },
                  then: "Dino shooter",
                },
                {
                  case: { $eq: ["$_id", 310] },
                  then: "FaFaFa",
                },
                {
                  case: { $eq: ["$_id", 318] },
                  then: "Party Night",
                },
                {
                  case: { $eq: ["$_id", 322] },
                  then: "Fortune Pig",
                },
                {
                  case: { $eq: ["$_id", 383] },
                  then: "Mines",
                },
                {
                  case: { $eq: ["$_id", 390] },
                  then: "Limbo",
                },
                {
                  case: { $eq: ["$_id", 395] },
                  then: "Mecha Jaeger",
                },
                {
                  case: { $eq: ["$_id", 411] },
                  then: "Plinko",
                },
                {
                  case: { $eq: ["$_id", 413] },
                  then: "ELF Bingo",
                },
                {
                  case: { $eq: ["$_id", 432] },
                  then: "Crash",
                },
                {
                  case: { $eq: ["$_id", 434] },
                  then: "Fortune Zombie",
                },
                {
                  case: { $eq: ["$_id", 450] },
                  then: "Zeus",
                },
                {
                  case: { $eq: ["$_id", 452] },
                  then: "Potion Wizard",
                },
                {
                  case: { $eq: ["$_id", 454] },
                  then: "3 Coin Treasures",
                },
                {
                  case: { $eq: ["$_id", 456] },
                  then: "The Pig House",
                },
                {
                  case: { $eq: ["$_id", 465] },
                  then: "3 Lucky Piggy",
                },
                {
                  case: { $eq: ["$_id", 481] },
                  then: "Devil Fire 2",
                },
                {
                  case: { $eq: ["$_id", 482] },
                  then: "Ascent Charge Buffalo",
                },
                {
                  case: { $eq: ["$_id", 493] },
                  then: "Fortune Gems Scratch",
                },
                {
                  case: { $eq: ["$_id", 510] },
                  then: "Money Pot",
                },
                {
                  case: { $eq: ["$_id", 556] },
                  then: "Lightning Fishooter",
                },
                {
                  case: { $eq: ["$_id", 566] },
                  then: "Jackpot Joker",
                },
                {
                  case: { $eq: ["$_id", 568] },
                  then: "3 Rich Piggies",
                },
                {
                  case: { $eq: ["$_id", 528] },
                  then: "Ocean Hunter",
                },
                {
                  case: { $eq: ["$_id", 530] },
                  then: "Fortune Zombie 2",
                },
                {
                  case: { $eq: ["$_id", 527] },
                  then: "Ocean King Jackpot",
                },
                {
                  case: { $eq: ["$_id", 647] },
                  then: "Crazy 777 2",
                },
                {
                  case: { $eq: ["$_id", 320] },
                  then: "Pirate Queen 2",
                },
                {
                  case: { $eq: ["$_id", 278] },
                  then: "Fortune Gems 3",
                },
                {
                  case: { $eq: ["$_id", 617] },
                  then: "Rapid Gems 777",
                },
                {
                  case: { $eq: ["$_id", 575] },
                  then: "Crystal 777 Deluxe",
                },
                {
                  case: { $eq: ["$_id", 614] },
                  then: "3 Lucky Lion",
                },
                {
                  case: { $eq: ["$_id", 615] },
                  then: "3 Coin Wild Horse",
                },
                {
                  case: { $eq: ["$_id", 565] },
                  then: "3 Coin Treasures 2",
                },
                {
                  case: { $eq: ["$_id", 616] },
                  then: "Coin Nonet",
                },
                {
                  case: { $eq: ["$_id", 556] },
                  then: "Lightning Fishhooter",
                },
                {
                  case: { $eq: ["$_id", 566] },
                  then: "Jackpot Joker",
                },
                {
                  case: { $eq: ["$_id", 568] },
                  then: "3 Rich Piggies",
                },{
                  case: { $eq: ["$_id", 1018] },
                  then: "Hexa Keno",
                },{
                  case: { $eq: ["$_id", 567] },
                  then: "Sweet Magic",
                },{
                  case: { $eq: ["$_id", 776] },
                  then: "Devil's Treasures Twins",
                },{
                  case: { $eq: ["$_id", 764] },
                  then: "Coin Nonet Clover",
                },{
                  case: { $eq: ["$_id", 650] },
                  then: "Clover Coins ",
                },{
                  case: { $eq: ["$_id", 756] },
                  then: "3 Lion Awakening",
                },{
                  case: { $eq: ["$_id", 784] },
                  then: "3 Lightning Blitz",
                },{
                  case: { $eq: ["$_id", 648] },
                  then: "Circus Joker 4096",
                },{
                  case: { $eq: ["$_id", 537] },
                  then: "Lucky Shooter",
                }        
              ],
              default: "$_id",
            },
          },
        },
      },
      {
        $sort: {
          count: -1,
        },
      },
    ];

    const resultTadaGame = await new Parse.Query("TadaGameHistory").aggregate(
      tadaPipeline,
      { useMasterKey: true }
    );

    // -------------------- MERGE, SORT, PAGINATE --------------------
    const combinedResults = [...resultVegasGame, ...resultTadaGame];
    combinedResults.sort((a, b) => b.count - a.count);
    const top10Games = combinedResults.slice(0, 9);

    return { top10Games };
  } catch (error) {
    console.log("hoteGames error:", error);
    return { error: "Failed to generate userEngagement." };
  }
};

// ---- TD master list (from your $switch) ----
const TADA_GAMES = new Map([
  [265, "Crazy 777"],
  [266, "Bone Fortune"],
  [267, "Money Coming"],
  [270, "Golden Joker"],
  [275, "Charge Buffalo"],
  [277, "Golden Bank"],
  [279, "Magic Lamp"],
  [281, "Alibaba"],
  [282, "Gold Rush"],
  [284, "Wild Racer"],
  [285, "Shanghai Beauty"],
  [296, "Mega Fishing"],
  [306, "Dino shooter"],
  [310, "FaFaFa"],
  [318, "Party Night"],
  [322, "Fortune Pig"],
  [383, "Mines"],
  [390, "Limbo"],
  [395, "Mecha Jaeger"],
  [411, "Plinko"],
  [413, "ELF Bingo"],
  [432, "Crash"],
  [434, "Fortune Zombie"],
  [450, "Zeus"],
  [452, "Potion Wizard"],
  [454, "3 Coin Treasures"],
  [456, "The Pig House"],
  [465, "3 Lucky Piggy"],
  [481, "Devil Fire 2"],
  [482, "Ascent Charge Buffalo"],
  [493, "Fortune Gems Scratch"],
  [510, "Money Pot"],
  [556, "Lightning Fishooter"],
  [566, "Jackpot Joker"],
  [568, "3 Rich Piggies"],
  [528, "Ocean Hunter"],
  [530, "Fortune Zombie 2"],
  [527, "Ocean King Jackpot"],
  [647, "Crazy 777 2"],
  [320, "Pirate Queen 2"],
  [278, "Fortune Gems 3"],
  [617, "Rapid Gems 777"],
  [575, "Crystal 777 Deluxe"],
  [614, "3 Lucky Lion"],
  [615, "3 Coin Wild Horse"],
  [565, "3 Coin Treasures 2"],
  [616, "Coin Nonet"],
  [1018, "Hexa Keno"],
  [567, "Sweet Magic"],
  [776, "Devil's Treasures Twins"],
  [764, "Coin Nonet Clover"],
  [650, "Clover Coins "],
  [756, "3 Lion Awakening"],
  [784, "3 Lightning Blitz"],
  [648, "Circus Joker 4096"],
  [537, "Lucky Shooter"],
]);

// fetch all GameCatalogue items (handles >1000)
async function fetchAllGameCatalogue() {
  const out = [];
  let skip = 0;
  const limit = 1000;
  while (true) {
    const q = new Parse.Query("GameCatalogue");
    q.select(["name"]);
    q.limit(limit);
    q.skip(skip);
    const batch = await q.find({ useMasterKey: true });
    out.push(...batch);
    if (batch.length < limit) break;
    skip += batch.length;
  }
  return out;
}

// export const gamePerformance = async () => {
//   const now = new Date();

// // 1. Get current UTC time
// const utcNow = new Date(
//   Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
// );

// // 2. Subtract 7 days
// const sevenDaysAgo = new Date(utcNow);
// sevenDaysAgo.setUTCDate(sevenDaysAgo.getUTCDate() - 7);

// // 3. Result
// console.log(sevenDaysAgo.toISOString(),"sevenDaysAgosevenDaysAgosevenDaysAgo"); // ✅ 2025-08-28T00:00:00.000Z

//   try {
//     // -------------------- TADA GAME PIPELINE (UNCHANGED) --------------------
//     const tadaPipeline = [
//       { $match: { createdAt: { $gte: sevenDaysAgo } } },
//       {
//         $group: {
//           _id: "$gameId",
//           totalSpins: { $sum: 1 },
//           winningSpins: { $sum: { $cond: [{ $ne: ["$winloseAmount", 0] }, 1, 0] } },
//           totalBetAmount: { $sum: "$betAmount" },
//           totalWinAmount: { $sum: "$winloseAmount" },
//         },
//       },
//       {
//         $project: {
//           _id: 1,
//           type: { $literal: "TD" },
//           gameName: {
//             $switch: {
//               branches: [
//                 { case: { $eq: ["$_id", 265] }, then: "Crazy 777" },
//                 { case: { $eq: ["$_id", 266] }, then: "Bone Fortune" },
//                 { case: { $eq: ["$_id", 267] }, then: "Money Coming" },
//                 { case: { $eq: ["$_id", 270] }, then: "Golden Joker" },
//                 { case: { $eq: ["$_id", 275] }, then: "Charge Buffalo" },
//                 { case: { $eq: ["$_id", 277] }, then: "Golden Bank" },
//                 { case: { $eq: ["$_id", 279] }, then: "Magic Lamp" },
//                 { case: { $eq: ["$_id", 281] }, then: "Alibaba" },
//                 { case: { $eq: ["$_id", 282] }, then: "Gold Rush" },
//                 { case: { $eq: ["$_id", 284] }, then: "Wild Racer" },
//                 { case: { $eq: ["$_id", 285] }, then: "Shanghai Beauty" },
//                 { case: { $eq: ["$_id", 296] }, then: "Mega Fishing" },
//                 { case: { $eq: ["$_id", 306] }, then: "Dino shooter" },
//                 { case: { $eq: ["$_id", 310] }, then: "FaFaFa" },
//                 { case: { $eq: ["$_id", 318] }, then: "Party Night" },
//                 { case: { $eq: ["$_id", 322] }, then: "Fortune Pig" },
//                 { case: { $eq: ["$_id", 383] }, then: "Mines" },
//                 { case: { $eq: ["$_id", 390] }, then: "Limbo" },
//                 { case: { $eq: ["$_id", 395] }, then: "Mecha Jaeger" },
//                 { case: { $eq: ["$_id", 411] }, then: "Plinko" },
//                 { case: { $eq: ["$_id", 413] }, then: "ELF Bingo" },
//                 { case: { $eq: ["$_id", 432] }, then: "Crash" },
//                 { case: { $eq: ["$_id", 434] }, then: "Fortune Zombie" },
//                 { case: { $eq: ["$_id", 450] }, then: "Zeus" },
//                 { case: { $eq: ["$_id", 452] }, then: "Potion Wizard" },
//                 { case: { $eq: ["$_id", 454] }, then: "3 Coin Treasures" },
//                 { case: { $eq: ["$_id", 456] }, then: "The Pig House" },
//                 { case: { $eq: ["$_id", 465] }, then: "3 Lucky Piggy" },
//                 { case: { $eq: ["$_id", 481] }, then: "Devil Fire 2" },
//                 { case: { $eq: ["$_id", 482] }, then: "Ascent Charge Buffalo" },
//                 { case: { $eq: ["$_id", 493] }, then: "Fortune Gems Scratch" },
//                 { case: { $eq: ["$_id", 510] }, then: "Money Pot" },
//                 { case: { $eq: ["$_id", 556] }, then: "Lightning Fishooter" },
//                 { case: { $eq: ["$_id", 566] }, then: "Jackpot Joker" },
//                 { case: { $eq: ["$_id", 568] }, then: "3 Rich Piggies" },
//               ],
//               default: "$_id",
//             },
//           },
//           hitRate: {
//             $cond: [
//               { $eq: ["$totalSpins", 0] },
//               0,
//               { $multiply: [{ $divide: ["$winningSpins", "$totalSpins"] }, 100] },
//             ],
//           },
//           averageBet: {
//             $cond: [
//               { $eq: ["$totalSpins", 0] },
//               0,
//               { $divide: ["$totalBetAmount", "$totalSpins"] },
//             ],
//           },
//           rtp: {
//             $cond: [
//               { $eq: ["$totalBetAmount", 0] },
//               0,
//               { $multiply: [{ $divide: ["$totalWinAmount", "$totalBetAmount"] }, 100] },
//             ],
//           },
//         },
//       },
//     ];
//     const resultTadaGame = await new Parse.Query("TadaGameHistory").aggregate(tadaPipeline, { useMasterKey: true });

//     // -------------------- VEGAS GAME PIPELINE (UNCHANGED) --------------------
//     const vegasPipeline = [
//       { $match: { createdAt: { $gte: sevenDaysAgo } } },
//       {
//         $addFields: {
//           gameSessionIdStr: {
//             $replaceOne: { input: "$_p_gameSessionId", find: "VegasGameHistory$", replacement: "" },
//           },
//         },
//       },
//       {
//         $lookup: {
//           from: "VegasGameHistory",
//           localField: "gameSessionIdStr",
//           foreignField: "_id",
//           as: "gameSessionData",
//         },
//       },
//       { $unwind: "$gameSessionData" },
//       {
//         $addFields: {
//           gameIdStr: {
//             $replaceOne: { input: "$gameSessionData._p_gameId", find: "GameCatalogue$", replacement: "" },
//           },
//         },
//       },
//       {
//         $lookup: {
//           from: "GameCatalogue",
//           localField: "gameIdStr",
//           foreignField: "_id",
//           as: "gameInfo",
//         },
//       },
//       { $unwind: "$gameInfo" },
//       {
//         $group: {
//           _id: "$gameInfo._id",
//           totalSpins: { $sum: 1 },
//           winningSpins: { $sum: { $cond: [{ $ne: ["$txn_type", 0] }, 1, 0] } },
//           gameIdStr: { $first: "$gameIdStr" },
//           gameName: { $first: "$gameInfo.name" },
//           totalWinAmount: { $sum: { $cond: [{ $eq: ["$txn_type", 0] }, "$amount", 0] } },
//           totalBetAmount: { $sum: { $cond: [{ $eq: ["$txn_type", 1] }, "$amount", 0] } },
//         },
//       },
//       {
//         $project: {
//           _id: 1,
//           type: { $literal: "VE" },
//           gameName: 1,
//           hitRate: {
//             $cond: [
//               { $eq: ["$totalSpins", 0] },
//               0,
//               { $multiply: [{ $divide: ["$winningSpins", "$totalSpins"] }, 100] },
//             ],
//           },
//           averageBet: {
//             $cond: [
//               { $eq: ["$totalSpins", 0] },
//               0,
//               { $divide: ["$totalBetAmount", "$totalSpins"] },
//             ],
//           },
//           rtp: {
//             $cond: [
//               { $eq: ["$totalBetAmount", 0] },
//               0,
//               { $multiply: [{ $divide: ["$totalWinAmount", "$totalBetAmount"] }, 100] },
//             ],
//           },
//         },
//       },
//     ];
//     const resultVegasGame = await new Parse.Query("VegasGameSpinHistory").aggregate(vegasPipeline, { useMasterKey: true });

//     // -------------------- append zero rows for missing games --------------------
//     // VE: compare with full GameCatalogue
//     const allVeGames = await fetchAllGameCatalogue();
//     const vePresent = new Set(resultVegasGame.map((r) => String(r._id)));
//     const veMissingZeroRows = allVeGames
//       .filter((g) => !vePresent.has(g.id))
//       .map((g) => ({
//         _id: g.id,
//         type: "VE",
//         gameName: g.get("name") || "",
//         hitRate: 0,
//         averageBet: 0,
//         rtp: 0,
//       }));

//     // TD: compare with full TADA list
//     const tdPresent = new Set(resultTadaGame.map((r) => String(r._id)));
//     const tdMissingZeroRows = Array.from(TADA_GAMES.entries())
//       .filter(([id]) => !tdPresent.has(String(id)))
//       .map(([id, name]) => ({
//         _id: id,
//         type: "TD",
//         gameName: name,
//         hitRate: 0,
//         averageBet: 0,
//         rtp: 0,
//       }));

//     // final result: played + zeroed missing
//     return [...resultVegasGame, ...veMissingZeroRows, ...resultTadaGame, ...tdMissingZeroRows];
//   } catch (error) {
//     console.log("gamePerformance error:", error);
//     return { error: "Failed to generate gamePerformance." };
//   }
// };

export const gamePerformance = async () => {
  const now = new Date();
  const utcNow = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
  const sevenDaysAgo = new Date(utcNow);
  sevenDaysAgo.setUTCDate(sevenDaysAgo.getUTCDate() - 7);

  try {
    const user = await Parse.User.current().fetch();
    const userId = user.id;

    const baseMatchStages = [
      { $match: { _rperm: userId } },
      { $match: { role: "Player" } },
      { $match: { gamePlayedDate: { $gte: sevenDaysAgo } } },
      { $match: { isTestingUserData: { $ne: true } } }, // skip test users
    ];

    const gameGroupPipeline = [
      ...baseMatchStages,
      {
        $group: {
          _id: "$gameId",
          gameName: { $first: "$gameName" },
          type: { $first: "$type" },
          totalSpins: { $sum: 1 },
          winningSpins: {
            $sum: {
              $cond: [{ $ne: ["$totalWinAmount", 0] }, 1, 0]
            }
          },
          totalBetAmount: { $sum: "$totalBetAmount" },
          totalWinAmount: { $sum: "$totalWinAmount" },
        },
      },
      {
        $project: {
          _id: 1,
          type: 1,
          gameName: 1,
          rtp: {
            $cond: [
              { $eq: ["$totalBetAmount", 0] },
              0,
              { $multiply: [{ $divide: ["$totalWinAmount", "$totalBetAmount"] }, 100] },
            ],
          },
          averageBet: {
            $cond: [
              { $eq: ["$totalSpins", 0] },
              0,
              { $divide: ["$totalBetAmount", "$totalSpins"] },
            ],
          },
          hitRate: {
            $cond: [
              { $eq: ["$totalSpins", 0] },
              0,
              { $multiply: [{ $divide: ["$winningSpins", "$totalSpins"] }, 100] },
            ],
          },
        },
      },
    ];

    const result = await new Parse.Query("GameCoins").aggregate(gameGroupPipeline, { useMasterKey: true });
    return result;
  } catch (error) {
    console.error("gamePerformanceFromGameCoins error:", error);
    return { error: "Failed to compute game performance from GameCoins." };
  }
};


export const userEngagement = async () => {
  try {
    // Get Yesterday's Login Count
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    yesterday.setHours(0, 0, 0, 0);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const yesterdayUsersQuery = new Parse.Query(Parse.User);
    yesterdayUsersQuery.greaterThanOrEqualTo("lastLogin", yesterday);
    yesterdayUsersQuery.lessThan("lastLogin", today);
    const yesterdayUsersCount = await yesterdayUsersQuery.count();

    // Get Last Week's Avg DAU
    let totalDAU = 0;
    for (let i = 1; i <= 7; i++) {
      // Use UTC dates to avoid timezone issues
      const now = new Date();
      const startDate = new Date(Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate() - i,
        0, 0, 0, 0
      ));

      const endDate = new Date(Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate() - i + 1,
        0, 0, 0, 0
      ));

      const dailyQuery = new Parse.Query(Parse.User);
      dailyQuery.greaterThanOrEqualTo("lastLogin", startDate);
      dailyQuery.lessThan("lastLogin", endDate);
      dailyQuery.select("username", "name", "lastLogin"); 
      const dailyActiveUsers = await dailyQuery.count();
      
      // const users = await dailyQuery.find();
      // const usernames = users.map(user => user.get("username") || user.get("name") || user.id);
      // const dateStr = startDate.toISOString().split('T')[0].substring(5); // Get "MM-DD"
      // const [month, day] = dateStr.split('-');
      // const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      // const formattedDate = `${months[parseInt(month) - 1]} ${parseInt(day)}`;
      // console.log(`Day ${i} (${formattedDate}): ${dailyActiveUsers} users - ${JSON.stringify(usernames)}`);
      totalDAU += dailyActiveUsers;
    }

    const lastWeekAvgCount = Math.round(totalDAU / 7);

    // Get This Month's Active Users Count
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const thisMonthQuery = new Parse.Query(Parse.User);
    thisMonthQuery.greaterThanOrEqualTo("lastLogin", firstDayOfMonth);
    const thisMonthUsersCount = await thisMonthQuery.count();

    // Get Last Month's Active Users Count
    const firstDayOfLastMonth = new Date(
      today.getFullYear(),
      today.getMonth() - 1,
      1
    );
    const firstDayOfNextMonth = new Date(
      today.getFullYear(),
      today.getMonth(),
      1
    );

    const lastMonthQuery = new Parse.Query(Parse.User);
    lastMonthQuery.greaterThanOrEqualTo("lastLogin", firstDayOfLastMonth);
    lastMonthQuery.lessThan("lastLogin", firstDayOfNextMonth);
    const lastMonthUsersCount = await lastMonthQuery.count();

    // Return all values with avgDAU as a number
    return {
      yesterdayUsersCount,
      lastWeekAvgCount,
      thisMonthUsersCount,
      lastMonthUsersCount,
    };
  } catch (error) {
    console.log("userEngagement error:", error);
    return { error: "Failed to generate userEngagement." };
  }
};

export async function fetchAccountSummaries({ username = "" }) {
  try {
    const userQuery = new Parse.Query(Parse.User);
    userQuery.include("role");
    userQuery.include("manager");

    // ✅ Apply username filter only
    if (username.trim()) {
      userQuery.matches("username", new RegExp(username, "i")); // case-insensitive
    }

    const users = await userQuery.find({ useMasterKey: true });

    // Format result
    const result = users.map((user) => ({
      id: user.id,
      userName: user.get("username"),
      roleName: user.get("role")?.get("name") || "",
      parentName: user.get("manager")?.get("username") || "",
    }));

    return {
      data: result,
      total: result.length,
    };
  } catch (err) {
    console.error("❌ Error fetching users by username:", err);
    return { data: [], total: 0 };
  }
}

export async function fetchUserTransactions({
  userId,
  startDate,
  endDate,
}) {
  if (!userId) return [];

  const txnQuery = new Parse.Query("Transactions");
  txnQuery.equalTo("userId", {
    __type: "Pointer",
    className: "_User",
    objectId: userId,
  });

  if (startDate) {
    txnQuery.greaterThanOrEqualTo("txn_datetime", new Date(startDate));
  }
  if (endDate) {
    const end = new Date(endDate);
    end.setDate(end.getDate() + 1); // include end date till 23:59
    txnQuery.lessThan("txn_datetime", end);
  }

  txnQuery.limit(1000); // adjust as needed
  txnQuery.ascending("txn_datetime");

  try {
    const txns = await txnQuery.find({ useMasterKey: true });

    const recharge = txns
      .filter((txn) => txn.get("txn_type") === 0)
      .reduce((sum, txn) => sum + (txn.get("amount") || 0), 0);

    const redeem = txns
      .filter((txn) => txn.get("txn_type") === 1)
      .reduce((sum, txn) => sum + (txn.get("amount") || 0), 0);

    return {
      transactions: txns,
      rechargeTotal: recharge,
      redeemTotal: redeem,
    };
  } catch (err) {
    console.error("❌ Error fetching user transactions:", err);
    return { transactions: [], rechargeTotal: 0, redeemTotal: 0 };
  }
}
